/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from "axios";

// AxiosErrorかどうかを判断し返す
export const isAxiosError = (error: any): error is AxiosError => {
    return !!error.isAxiosError;
};
